import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import { parseISO, startOfWeek, endOfWeek, format } from 'date-fns';

function UserFeedbackChart({ data }) {
    useEffect(() => {
        if (!data || !data.labels || data.labels.length === 0) {
            return; // Don't attempt to render the chart if there's no data
        }

        const chartDom = document.getElementById('user-feedback-chart');
        const myChart = echarts.init(chartDom);

        // Given JSON data
        const jsonData = data;

        // Prepare the data
        const weekRanges = {};
        jsonData.labels.forEach((label, index) => {
            const date = parseISO(label);
            const startOfWeekDate = startOfWeek(date);
            const endOfWeekDate = endOfWeek(date);
            const weekRange = `${format(startOfWeekDate, 'MMM d')} - ${format(endOfWeekDate, 'd')}`;
            if (!weekRanges[weekRange]) {
                weekRanges[weekRange] = {};
            }

            Object.keys(jsonData.data).forEach(key => {
                if (!weekRanges[weekRange][key]) {
                    weekRanges[weekRange][key] = 0;
                }
                weekRanges[weekRange][key] += jsonData.data[key][index];
            });
        });

        const weekLabels = Object.keys(weekRanges);
        const colors = ['#053F98', '#4A558A', '#4D88A3', '#96D4E5'];
        const seriesData = Object.keys(jsonData.data).map((key, index) => {
            return {
                name: key,
                type: 'bar',
                stack: 'total',
                data: weekLabels.map(week => weekRanges[week][key] || 0),
                itemStyle: {
                    color: colors[index % colors.length]
                }
            };
        });

        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow' // Default is 'line', but you can also set to 'shadow'
                }
            },
            legend: {
                data: seriesData.map(item => item.name),
                type: 'scroll',
                orient: 'horizontal',
                top: 10,
                bottom: 'auto',
            },
            xAxis: {
                type: 'category',
                data: weekLabels
            },
            yAxis: {
                type: 'value'
            },
            series: seriesData
        };

        myChart.setOption(option);

        // Handle window resize
        const handleResize = () => {
            myChart.resize();
        };

        window.addEventListener('resize', handleResize);

        // Clean up the chart and event listener on unmount or when data changes
        return () => {
            myChart.dispose();
            window.removeEventListener('resize', handleResize);
        };
    }, [data]);

    return <div id="user-feedback-chart" style={{ height: 400, width: '100%' }}></div>;
}

export default UserFeedbackChart;
